function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "Google_svg__26_a",
  d: "M21.923 9.23H11.077v4.616h6.461c-.566 2.832-3.06 4.51-6.203 4.51-3.71 0-6.698-3.041-6.698-6.818 0-3.776 2.988-6.818 6.698-6.818 1.597 0 3.04.577 4.173 1.521l3.297-3.356C16.795 1.1 14.22 0 11.335 0 5.049 0 0 5.14 0 11.538c0 6.4 5.049 11.539 11.335 11.539 5.667 0 10.819-4.196 10.819-11.539 0-.681-.076-1.625-.23-2.307z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(.923)"
}, React.createElement("mask", {
  id: "Google_svg__27_b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#Google_svg__26_a"
})), React.createElement("path", {
  fill: "#34A853",
  fillRule: "nonzero",
  mask: "url(#Google_svg__27_b)",
  d: "M-1.03 18.357L14.426 6.294l4.07.524 5.203-7.867v25.175H-1.03z"
}), React.createElement("path", {
  fill: "#4285F4",
  fillRule: "nonzero",
  mask: "url(#Google_svg__27_b)",
  d: "M23.699 24.126L7.728 11.538 5.667 9.965 23.699 4.72z"
}), React.createElement("path", {
  fill: "#EA4335",
  fillRule: "nonzero",
  mask: "url(#Google_svg__27_b)",
  d: "M-1.03 4.72l8.758 6.818 3.607-3.199 12.364-2.045v-7.343H-1.03z"
}), React.createElement("path", {
  fill: "#FBBC05",
  fillRule: "nonzero",
  mask: "url(#Google_svg__27_b)",
  d: "M-1.03 18.357V4.72l8.758 6.818z"
}));

var SvgGoogle = function SvgGoogle(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default SvgGoogle;